import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import SubSample from './pages/SubSample';
import SingleSample from './pages/SingleSample';
import Info from './pages/Info';
import { ThemeProvider } from './theme/ThemeContext';
import ErrorBoundary from './components/errorBoundary.jsx';



const Router = () => {
    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ThemeProvider>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/Info" element={<Info />} />
                        <Route path="/sample" element={<SingleSample />} />
                        <Route path="/subsample" element={<SubSample />} />
                    </Routes>
                </ThemeProvider>
            </BrowserRouter>
        </ErrorBoundary>
    );
};

export default Router;